export const InstanceSurveysActionTypes = {
  API_RESPONSE_SUCCESS: '@@instance-survey/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@instance-survey/API_RESPONSE_ERROR',

  GET_INSTANCE_SURVEY: '@@instance-survey/GET_INSTANCE_SURVEY',
  LIST_INSTANCE_SURVEYS: '@@instance-survey/LIST_INSTANCE_SURVEYS',
  ADD_INSTANCE_SURVEY: '@@instance-survey/ADD_INSTANCE_SURVEY',
  UPDATE_INSTANCE_SURVEY: '@@instance-survey/UPDATE_INSTANCE_SURVEY',
  DELETE_INSTANCE_SURVEY: '@@instance-survey/DELETE_INSTANCE_SURVEY',

  ADD_INSTANCE_SURVEY_QR: '@@instance-survey/ADD_INSTANCE_SURVEY_QR',
  UPDATE_INSTANCE_SURVEY_QR: '@@instance-survey/UPDATE_INSTANCE_SURVEY_QR',

  RESET: '@@instance-survey/RESET'
}
